import { ChangeDetectionStrategy, Component, computed, EventEmitter, input, Output } from '@angular/core'
import { Icon, IconColor, IconComponent } from '@ftr/foundation'
import { SttMarkerType } from '../../features'

export interface RealTimeSttMarkerIconInputs {
  type: SttMarkerType
  interactive: boolean
}

const MARKER_ICON: Record<SttMarkerType, Icon> = {
  [SttMarkerType.Hearing]: 'FolderOpen',
  [SttMarkerType.Sealing]: 'Lock',
  [SttMarkerType.Session]: 'Mic',
}

const MARKER_COLOR: Record<SttMarkerType, IconColor> = {
  [SttMarkerType.Hearing]: 'Secondary',
  [SttMarkerType.Sealing]: 'GreyLight',
  [SttMarkerType.Session]: 'Primary',
}

@Component({
  selector: 'ftr-real-time-stt-marker-icon',
  templateUrl: './real-time-stt-marker-icon.component.html',
  styleUrls: ['./real-time-stt-marker-icon.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [IconComponent],
})
export class RealTimeSttMarkerIconComponent {
  public type = input.required<SttMarkerType>()
  public interactive = input<boolean>(false)
  protected readonly icon = computed(() => this.getIcon())
  protected readonly color = computed(() => this.getColor())

  @Output() iconClick = new EventEmitter<void>()

  getIcon(): Icon {
    return MARKER_ICON[this.type()]
  }

  getColor(): IconColor {
    return MARKER_COLOR[this.type()]
  }

  click(): void {
    this.iconClick.emit()
  }
}
